<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->

<tp-multi-panel
	class="multi-panel-ticketspace-fit"
	*ngIf="planTicketsFilterRemoteControlService.openPlanTicketsFilter$ | async"
>
	<plan-tickets-filter
		multiPanelItem
		[projectId]="planState.projectId"
		[userId]="appState.userId | async"
		[planTickets]="ticketListForFiltering$"
		[customFields]="planState.customFieldsApi.getDefinitions().data.list$"
		[roleOptions]="planState.rolesApi.data.list$"
		[swimlaneOptions]="planState.swimlanes.data.list$"
		[locationOptions]="planState.locationsApi.data.list$"
		[ticketCustomFields]="ticketCustomFieldMapping$ | async"
		[quickSearch]="planTicketsFilterRemoteControlService.quickSearchValue$ | async"
		(matchingTicketsChange)="onMatchingTicketsChange($event?.tickets)"
		[ticketAttachments]="ticketAttachmentsForFiltering$"
	></plan-tickets-filter>
	<tp-filtered-ticket-list-panel
		multiPanelItem
		[tickets]="matchingTickets$"
		(ticketClick)="onFocusTicketFromFilterTicketList($event)"
		(transparencyChange)="onTransparencyChange($event)"
	></tp-filtered-ticket-list-panel>
</tp-multi-panel>
<tp-plan-print-panel
	*ngIf="planPrintPanelRemoteControlService.enablePlanPrintSettings$ | async"
></tp-plan-print-panel>
